import React, { useState } from 'react';
import { CircleCheck, CircleX } from 'lucide-react';
import { getApiUrl } from '../../utils/apiConfig';

const emptyPermiso = {
  EmailUser: '',
  FuncionComercial: '',
  C_Comerciales: '',
  O_Bloques: '',
  O_Ubicaciones: '',
};

const NewAdministracionContent = ({ onSave, onCancel }) => {
  const [permiso, setPermiso] = useState(emptyPermiso);
  const [saving, setSaving] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPermiso(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setErrorMsg('');
    setSuccessMsg('');
    try {
      const res = await fetch(getApiUrl('/api/permisosAdmin'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(permiso),
      });
      if (res.ok) {
        setSuccessMsg('Permiso creado correctamente');
        onSave && onSave();
      } else {
        setErrorMsg('Error al crear el permiso');
      }
    } catch (err) {
      setErrorMsg('Error de red');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto bg-white rounded-2xl shadow-xl p-6">
      <h2 className="text-xl font-bold mb-4">Nuevo Permiso Comercial</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Email</label>
          <input type="email" name="EmailUser" value={permiso.EmailUser} onChange={handleChange} required className="w-full px-3 py-2 border rounded-xl" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Función Comercial</label>
          <input type="text" name="FuncionComercial" value={permiso.FuncionComercial} onChange={handleChange} className="w-full px-3 py-2 border rounded-xl" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Comerciales</label>
          <input type="text" name="C_Comerciales" value={permiso.C_Comerciales} onChange={handleChange} className="w-full px-3 py-2 border rounded-xl" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Bloques</label>
          <input type="text" name="O_Bloques" value={permiso.O_Bloques} onChange={handleChange} className="w-full px-3 py-2 border rounded-xl" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Ubicaciones</label>
          <input type="text" name="O_Ubicaciones" value={permiso.O_Ubicaciones} onChange={handleChange} className="w-full px-3 py-2 border rounded-xl" />
        </div>
        {errorMsg && <div className="text-red-600 text-sm flex items-center gap-2"><CircleX size={16} /> {errorMsg}</div>}
        {successMsg && <div className="text-green-600 text-sm flex items-center gap-2"><CircleCheck size={16} /> {successMsg}</div>}
        <div className="flex gap-3 justify-end mt-4">
          <button type="button" onClick={onCancel} className="px-4 py-2 rounded-xl bg-gray-200 text-gray-700">Cancelar</button>
          <button type="submit" disabled={saving} className="px-4 py-2 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700 transition-all">{saving ? 'Guardando...' : 'Guardar'}</button>
        </div>
      </form>
    </div>
  );
};

export default NewAdministracionContent;
